import { BrowserCacheResourceConfig } from '@pp/core';

import lastResultStroke from '../components/recentResults/spinResult/assets/borders/default-stroke.svg';
import betOnAll from '../components/gameGrid/betSpot/assets/betOnAll.svg';
import betOnAllArrow from '../components/gameGrid/betSpot/assets/arrows.svg';
import betOnAllArrowLarge from '../components/gameGrid/betSpot/assets/arrowlarge.svg';

export const Resources: BrowserCacheResourceConfig = {
  /* fonts */
  CUSTOM: { url: './assets/fonts/Poppins-Bold-subset.woff2', priority: 'block', kind: 'font' } /* game custom */,

  /* images */
  LAST_RESULT_STROKE: { url: lastResultStroke, priority: 'block', kind: 'image' },

  BETONALL: { url: betOnAll, priority: 'block', kind: 'image' },
  BETONALL_ARROW: { url: betOnAllArrow, priority: 'block', kind: 'image' },
  BETONALL_ARROW_LARGE: { url: betOnAllArrowLarge, priority: 'block', kind: 'image' },
};
